var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"absolute":"","id":"footer"}},[_c('div',{staticClass:"row d-flex justify-content-center align-content-center",attrs:{"id":"footer"}},[_c('span',[_vm._v(" Made with "),_c('i',{staticClass:"fas fa-heart ml-2",staticStyle:{"color":"#e25555"}})]),_c('span',{staticClass:"ml-3"},[_vm._v("© All rights Reversed")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }